import React from 'react';
import QR from 'assets/svgs/common/qr-code.svg';
import SocialIcons from 'components/Socials';
import {ReactComponent as ArrowIcon} from 'assets/svgs/actions/arrow-button.svg';
import history from 'utils/history';
import QRCode from 'qrcode.react';
import {ReactComponent as FileIcon} from 'assets/svgs/file-upload/attachment-circle.svg';
import {ReactComponent as CompanyIcon} from 'assets/svgs/company/profile.svg';
import {ReactComponent as AboutIcon} from 'assets/svgs/company/about.svg';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import {getStatusOfPostCompany} from '../../utils/status';
import {PARTNER_DOMAIN} from '../../config';

const CompanyInfo = ({
  company,
  activeSection,
  setActiveSection,
  isBack,
  className,
  containerClass,
  canAccessCloud = true,
}) => {
  const status = getStatusOfPostCompany(company);
  const getUrl = () => {
    if (!company || !company.website) return '';
    return company.website.startsWith('http')
      ? company.website
      : `https://${company.website}`;
  };

  return (
    <>
      <div
        // ${ status ?  status.className : '' }-border ${containerClass || ''}
        className={`box-dashboard  d-flex  justify-content-center align-items-center bg-white mb-4 `}
      >
        {isBack && (
          <div
            className={`arrow-buttons-company left d-flex justify-content-center ${
              !isBack ? 'disabled' : ''
            }`}
          >
            <button
              type="button"
              className="btn-link d-flex justify-content-center align-items-center back"
              onClick={() => {
                history.goBack();
              }}
            >
              <ArrowIcon />
            </button>
          </div>
        )}

        <div
          className={`mx-4 table-profiles updated d-flex flex-column company-blue ${className}`}
        >
          <div className="d-flex w-100 h-100">
            <div className="w-100 d-flex mr-3">
              <div className="company-logo border-outline btn-gray4 mr-3">
                {company?.logoId?.liveURL && (
                  <a
                    href={`${PARTNER_DOMAIN}/${company.partnerId}/${
                      company.profileUrl || ''
                    }`}
                  >
                    <img
                      src={`${company.logoId.liveURL}`}
                      className="object-fit-contain h-100 w-100"
                      alt=""
                    />
                  </a>
                )}
              </div>
              <div className="d-flex w-100 flex-column">
                <div className="w-100 border-outline input-type btn-gray4 mb-3 d-flex align-items-center">
                  <span className="mr-2">
                    {' '}
                    {`${
                      company && company.telephone ? company.telephone : ''
                    }`}{' '}
                  </span>
                  <span className="mr-2">
                    {' '}
                    {`${company && company.fax ? company.fax : ''}`}{' '}
                  </span>
                </div>
                <div className="w-100 border-outline input-type btn-gray4 mb-3 d-flex align-items-center text-lowercase">
                  {company && company.email && (
                    <span className="mr-2"> {`${company.email}`} </span>
                  )}
                </div>
              </div>
            </div>
            <div className="w-100 social-side d-flex align-items-center btn-gray4 border-outline">
              {company && <SocialIcons data={company} />}
            </div>
          </div>
          <div className="d-flex w-100 h-100">
            <div className="w-100 mr-3 d-flex flex-column">
              <div className="d-flex w-100">
                <div className="border-outline input-type btn-gray4 mb-3 mr-3 c-name d-flex align-items-center">
                  {company && company.companyName && (
                    <span className="mr-2"> {`${company.companyName}`} </span>
                  )}
                </div>
                <div className="border-outline text-lowercase input-type btn-gray4 mb-3 d-flex web-name align-items-center">
                  {company && company.website && (
                    <span className="mr-2 "> {`${company.website}`} </span>
                  )}
                </div>
              </div>
              <div className="d-flex w-100">
                <div className="w-100 border-outline input-type btn-gray4 mb-3 d-flex align-items-center">
                  {company && company.address && (
                    <span className="mr-2"> {`${company.address}`} </span>
                  )}
                </div>
              </div>
            </div>
            <div className="qr-code  bg-gray4 border-outline d-flex align-items-center justify-content-center">
              {company && company.website ? (
                <a href={getUrl()} target="_blank">
                  <QRCode
                    className="w-100 h-100"
                    style={{height: 70}}
                    value={getUrl()}
                  />
                </a>
              ) : (
                <img src={QR} className="w-100 d-none" alt="" />
              )}
            </div>
          </div>
        </div>

        {activeSection && (
          <div className="d-flex h-100 flex-column align-items-between justify-content-between pro-co-act-icon">
            <ReactTooltip
              id="company-icon"
              place="right"
              type="warning"
              effect="solid"
            >
              Profile
            </ReactTooltip>

            <ReactTooltip
              id="about-icon"
              place="right"
              type="warning"
              effect="solid"
            >
              About
            </ReactTooltip>
            <CompanyIcon
              data-tip
              data-for="company-icon"
              className={`pointer mt-4 ${
                activeSection === 'profile' ? 'active' : ''
              }`}
              onClick={() => setActiveSection('profile')}
            />

            {canAccessCloud && company && company._id && (
              <>
                <a
                  href={`/company/cloud/${company.partnerId}`}
                  data-tip
                  data-for="file-icon-tooltip"
                  target="_blank"
                >
                  <FileIcon />
                </a>
                <ReactTooltip
                  id="file-icon-tooltip"
                  place="right"
                  type="warning"
                  effect="solid"
                >
                  Cloud
                </ReactTooltip>
              </>
            )}
            <AboutIcon
              data-tip
              data-for="about-icon"
              className={`pointer mb-4 ${
                activeSection === 'about' ? 'active' : ''
              }`}
              onClick={() => setActiveSection('about')}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CompanyInfo;
